export const displayValue = (value: any) => {
  return value ? value : '-';
};
